import React, { useState } from 'react';
import { Mail, X, CheckCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../../config/api.js';

const EmailVerificationModal = ({ email, companyName, onClose, onResend }) => {
  const [isResending, setIsResending] = useState(false);

  const handleResend = async () => {
    if (isResending) return;
    
    setIsResending(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/company/resend-verification`, {
        email: email
      });
      
      toast.success('Verifikacioni email je ponovo poslat. Proverite vašu poštu.');
      if (onResend) {
        onResend();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || 
        'Greška prilikom slanja verifikacionog emaila.'
      );
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-gray-800 rounded-lg shadow-xl p-8 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-blue-500 rounded-full p-4">
              <Mail className="h-12 w-12 text-white" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-white mb-4">
            Proverite vašu email adresu
          </h2>

          <p className="text-gray-300 mb-4">
            Poslali smo verifikacioni link na adresu:
          </p>

          <p className="text-blue-400 font-semibold mb-6 break-all">
            {email}
          </p>

          <div className="bg-blue-900 bg-opacity-30 border border-blue-500 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <CheckCircle className="h-5 w-5 text-blue-400 mt-0.5 mr-3 flex-shrink-0" />
              <div className="text-left">
                <p className="text-gray-300 text-sm">
                  <strong>Koraci za verifikaciju:</strong>
                </p>
                <ol className="text-gray-400 text-sm mt-2 space-y-1 list-decimal list-inside">
                  <li>Proverite vašu email poštu</li>
                  <li>Kliknite na link u emailu</li>
                  <li>Vaš nalog će biti aktiviran</li>
                </ol>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={handleResend}
              disabled={isResending}
              className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition-colors flex items-center justify-center ${
                isResending ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              <Mail className="h-5 w-5 mr-2" />
              {isResending ? 'Slanje...' : 'Pošalji ponovo verifikacioni email'}
            </button>

            <button
              onClick={onClose}
              className="w-full bg-gray-600 hover:bg-gray-700 text-white font-bold py-3 px-4 rounded-lg transition-colors"
            >
              Zatvori
            </button>
          </div>

          <p className="text-gray-400 text-xs mt-6">
            Niste dobili email? Proverite spam folder ili kliknite na "Pošalji ponovo"
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal;
